import { z } from 'zod';
export const zoneCodeSchema = z.string().regex(/^[A-Z][A-Z0-9]{0,2}$/, 'Zona kodi noto\'g\'ri (masalan: A, B1)');
export const rackCodeSchema = z.string().regex(/^\d{2,3}$/, 'Stellaj kodi 2-3 raqamdan iborat bo\'ladi');
const PART = /^([A-Z][A-Z0-9]{0,2})-(\d{2,3})-(\d{2})-(\d{2})$/;
/**
 * Katak kodini yasaydi (masalan `A-03-02-05`). Bu kod fizik shtrix-kod
 * etiketkasiga bosiladi — bir marta yaratilgach o'zgarmaydi.
 */
export const formatCellCode = (input) => {
    const zone = zoneCodeSchema.safeParse(input.zoneCode);
    if (!zone.success)
        throw new Error('Zona kodi noto\'g\'ri');
    const rack = rackCodeSchema.safeParse(input.rackCode);
    if (!rack.success)
        throw new Error('Stellaj kodi noto\'g\'ri');
    if (!Number.isInteger(input.level) || input.level < 1 || input.level > 99) {
        throw new Error('Qator raqami 1 dan 99 gacha bo\'lishi kerak');
    }
    if (!Number.isInteger(input.idx) || input.idx < 1 || input.idx > 99) {
        throw new Error('Katak raqami 1 dan 99 gacha bo\'lishi kerak');
    }
    const pad = (n) => String(n).padStart(2, '0');
    return `${input.zoneCode}-${input.rackCode}-${pad(input.level)}-${pad(input.idx)}`;
};
/** Katak kodini qismlarga ajratadi. Format noto'g'ri bo'lsa `null` qaytaradi, xato tashlamaydi. */
export const parseCellCode = (code) => {
    const m = PART.exec(code);
    if (m === null)
        return null;
    const [, zoneCode, rackCode, level, idx] = m;
    if (zoneCode === undefined || rackCode === undefined || level === undefined || idx === undefined)
        return null;
    return { zoneCode, rackCode, level: Number(level), idx: Number(idx) };
};
//# sourceMappingURL=cell-code.js.map